import { combineReducers } from 'redux';
import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';

export default combineReducers({
    isLoggedIn: simpleReducer(false, {
        RECEIVED_OFFERS: true,
        RECEIVED_USER: true,
        AUTH_ERROR: false,
    }),

    wantLogin: simpleReducer(false, {
        WANT_LOGIN: (a) => a.payload.wantLogin,
        RECEIVED_OFFERS: false,
        RECEIVED_USER: false,
        AUTH_ERROR: true,
    }),

    xsrfToken: simpleReducer('', {
        STORE_XSRF_TOKEN: (a) => a.payload.xsrfToken,
    }),
});



// WEBPACK FOOTER //
// ./app/reducers/login.js